import CalendarBoardProject from './CalendarBoardProject';
import type { CalendarBoardProps } from '../schema';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { getFirstFocusable } from '@fluentui/react/lib/Utilities';
import * as styles from './styles.scss';

export default observer(function CalendarBoard({
    assetRegistry,
    canvasBounds,
    boardRefHandler,
}: CalendarBoardProps) {
    const boardRef = React.useRef<HTMLDivElement | null>(null);

    React.useImperativeHandle(
        boardRefHandler,
        () => ({
            /**
             * Sets focus to first focusable board element
             */
            focusBoardChild() {
                if (!boardRef.current || boardRef.current.focus) {
                    throw new Error(
                        'Cannot set focus on board when component ref is not initialized'
                    );
                }
                const focusBoard = getFirstFocusable(boardRef.current, boardRef.current, true);
                if (focusBoard) {
                    focusBoard.focus();
                }
            },
        }),
        []
    );

    return (
        <div ref={boardRef} className={styles.boardContainer}>
            <CalendarBoardProject assetRegistry={assetRegistry} canvasBounds={canvasBounds} />
        </div>
    );
});
